export class Surcharge {
  Id: string;
  Name: string;
  Type: number;
}
